import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { fetchPositionById } from "../../../services/Axios";
import PositionForm from "./PositionForm";

export default function CopyPosition() {
  const { id } = useParams();
  const [positionData, setPositionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await fetchPositionById(id);
        if (data) {
          delete data.id;
          setPositionData(data);
        } else {
          setError("Position not found");
        }
      } catch (error) {
        console.error("Error fetching position:", error);
        setError("Failed to fetch position data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!positionData) return <div>Position not found</div>;

  return <PositionForm initialData={positionData} mode="create" />;
}
